import { useState } from "react";
import { CoreIcon } from "remirror";
import { CommandButton } from "@remirror/react-ui";
import { ColorPickerPopover } from "../../../ColorPicker";

export const ColorButton = ({
  name,
  color,
  setColor,
  icon,
  label,
}: {
  name: string;
  color: string;
  setColor: (color: string) => void;
  icon: CoreIcon | JSX.Element;
  label: string;
}) => {
  const [colorAnchor, setColorAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <CommandButton
        commandName={name}
        enabled={true}
        icon={icon}
        onClick={(e) => setColorAnchor(e.currentTarget)}
        onSelect={() => {}}
        label={label}
      />
      <ColorPickerPopover
        color={color}
        setColor={(color) => {
          setColor(color);
          setColorAnchor(null);
        }}
        anchor={colorAnchor}
        onClose={() => setColorAnchor(null)}
      />
    </>
  );
};
